import React, { useEffect, useState } from 'react';
// import { APP_KEY, API_URL } from './../config';
// import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import { getTransactionId } from '../../Utils/Common';
import { FUND_REQUEST_SAVE } from '../../Utils/appConstants';
// import { getPaymentMode, /* getBankMode */ } from './../../Utils/function';
import { postRequest } from '../../Utils/AppApi';
// import AppHeader from '../Header/Header';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
// import { data } from 'jquery';
import ComplaintSubmit from './../../container/complaintSubmit';
import { Divider, Tooltip, Modal, DatePicker, Select, Tabs, Card, Form, Input, Button, Typography, Alert, Row, Col } from 'antd';
import moment from 'moment';

const { Title } = Typography;
const { TextArea } = Input;

function Complaint(props) {
    const history = useHistory();
    const dateFormat = 'DD-MM-YYYY';
    const [getDataField, setDataField] = useState({});
    const [getDataError, setDataError] = useState({});
    const [isSubmit, setSubmit] = useState(false);
    const [historyData, setHistoryData] = useState([{
        "date": "12-11-2023",
        "transactionId": "txt74372738",
        "mobile": "9786523214",
        "biller": "JVVNL",
        "amount": "276",
        "typeOfComplaint": "Payment Issue",
        "participationType": "individual",
        "serviceReason": "payment_failure",
        "description": "Hi I have issue with payment",
        "status": "Pending",
    }, {
        "date": "13-11-2023",
        "transactionId": "txt74372739",
        "mobile": "9786523214",
        "biller": "JVVNL",
        "amount": "3000",
        "typeOfComplaint": "Billing Dispute",
        "participationType": "group",
        "serviceReason": "billing_issue",
        "description": "my bill pending please check",
        "status": "Resolved",
    }, {
        "date": "14-11-2023",
        "transactionId": "txt74372740",
        "mobile": "9786523214",
        "biller": "JVVNL",
        "amount": "2901",
        "typeOfComplaint": "Display Error",
        "participationType": "individual",
        "serviceReason": "other",
        "description": "my bill is success but still is now showing",
        "status": "Resolved",
    }]);
    const [filteredData, setFilteredData] = useState(historyData);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [searchBy, setSearchBy] = useState("ID");
    const [searchValue, setSearchValue] = useState("");
    const [complaintId, setComplaintId] = useState("");
    const [serviceType, setServiceType] = useState("");
    const [statusResult, setStatusResult] = useState(null);

    const [form] = Form.useForm();
    const [statusForm] = Form.useForm();
    const [historyForm] = Form.useForm();

    const participationMap = {
        individual: 'Individual',
        group: 'Group',
        organization: 'Organization',
    };

    const serviceMap = {
        billing_issue: 'Billing Issue',
        payment_failure: 'Payment Failure',
        service_outage: 'Service Outage',
        other: 'Other',
    };

    const columns = [{
        name: 'Date',
        selector: row => <><Tooltip title={row.date}>{row.date}</Tooltip></>,
    }, {
        name: 'Transaction ID',
        selector: row => <><Tooltip title={row.transactionId}>{row.transactionId}</Tooltip></>,
    }, {
        name: 'Mobile',
        selector: row => <><Tooltip title={row.mobile}>{row.mobile}</Tooltip></>,
    }, {
        name: 'Biller',
        selector: row => <><Tooltip title={row.biller}>{row.biller}</Tooltip></>,
    }, {
        name: 'Amount',
        selector: row => <><Tooltip title={row.amount}>{row.amount}</Tooltip></>,
    }, {
        name: 'Type Of Complaint',
        selector: row => <><Tooltip title={row.typeOfComplaint}>{row.typeOfComplaint}</Tooltip></>,
    }, {
        name: 'Participation Type',
        selector: row => <><Tooltip title={row.participationType}>{participationMap[row.participationType] || row.participationType}</Tooltip></>,
    }, {
        name: 'Service Reason',
        selector: row => <><Tooltip title={row.serviceReason}>{serviceMap[row.serviceReason] || row.serviceReason}</Tooltip></>,
    }, {
        name: 'Description',
        selector: row => <><Tooltip title={row.description}>{row.description}</Tooltip></>,
    }, {
        name: 'Status',
        selector: row => <><Tooltip title={row.status}>{row.status}</Tooltip></>,
    }]

    const FormValidate = () => {
        let formValid = true;
        let formObject = {};
        setDataError({})

        if (!getDataField.mobile || getDataField.mobile.trim() === "") {
            formObject.mobile = true;
            formValid = false;
        }

        if (!getDataField.biller || getDataField.biller.trim() === "") {
            formObject.biller = true;
            formValid = false;
        }

        if (!getDataField.amount || getDataField.amount === "") {
            formObject.amount = true;
            formValid = false;
        }

        if (!getDataField.typeOfComplaint || getDataField.typeOfComplaint === "") {
            formObject.typeOfComplaint = true;
            formValid = false;
        }

        if (!getDataField.participationType || getDataField.participationType === "") {
            formObject.participationType = true;
            formValid = false;
        }

        if (!getDataField.serviceReason || getDataField.serviceReason === "") {
            formObject.serviceReason = true;
            formValid = false;
        }

        if (!getDataField.description || getDataField.description.trim() === "") {
            formObject.description = true;
            formValid = false;
        }

        setDataError(formObject);
        return formValid;
    }

    const handleSubmit = async () => {
        if (FormValidate()) {
            try {
                const transactionId = await getTransactionId();
                const payload = {
                    mobile: getDataField.mobile,
                    biller: getDataField.biller,
                    amount: getDataField.amount,
                    typeOfComplaint: getDataField.typeOfComplaint,
                    participationType: getDataField.participationType,
                    serviceReason: getDataField.serviceReason,
                    description: getDataField.description,
                    transactionId: transactionId,
                }
                const response = await postRequest(FUND_REQUEST_SAVE, payload, history);
                if (response.success === true) {
                    const newEntry = {
                        date: moment().format('DD-MM-YYYY'),
                        transactionId: transactionId,
                        mobile: getDataField.mobile,
                        biller: getDataField.biller,
                        amount: getDataField.amount,
                        typeOfComplaint: getDataField.typeOfComplaint,
                        participationType: getDataField.participationType,
                        serviceReason: getDataField.serviceReason,
                        description: getDataField.description,
                        status: "Pending",
                    };
                    setHistoryData(prev => [newEntry, ...prev]);
                    setDataField({});
                    setDataError({});
                    form.resetFields();
                    toast.success(response.message);
                    setSubmit(true);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                // console.log(error)
                // setLoading(false);
            }
        }
    } // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeValue = (name, value) => {
        setDataField({ ...getDataField, [name]: value });
        // Clear error if present
        if (getDataError[name]) {
            setDataError({ ...getDataError, [name]: false });
        }
    }

    const getID = async () => {
        return await getTransactionId();
    }

    const handleSearch = () => {
        let filtered = [...historyData];
        const fieldMap = { ID: 'transactionId', mobile: 'mobile' };

        if (fromDate) {
            filtered = filtered.filter(row => moment(row.date, 'DD-MM-YYYY').isSameOrAfter(fromDate, 'day'));
        }

        if (toDate) {
            filtered = filtered.filter(row => moment(row.date, 'DD-MM-YYYY').isSameOrBefore(toDate, 'day'));
        }

        if (searchValue) {
            const field = fieldMap[searchBy];
            if (field) {
                filtered = filtered.filter(row => row[field].toString().toLowerCase().includes(searchValue.toLowerCase()));
            }
        }

        setFilteredData(filtered);
    }

    const handleStatusCheck = () => {
        if (!complaintId.trim() || !serviceType) {
            toast.error("Please fill Complaint ID and select Service Type");
            return;
        }
        // Simulate status check - in real app, call API
        const mockStatus = "Resolved"; // or fetch from API
        setStatusResult({ complaintId, serviceType, status: mockStatus });
        toast.success(`Status for Complaint ${complaintId}: ${mockStatus}`);
    };

    useEffect(() => {
        setFilteredData(historyData);
    }, [historyData]);

    return (
        <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh', padding: '20px' }}>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Card style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                        <Tabs defaultActiveKey="new" className="w-100" tabBarStyle={{ color: '#1890ff' }}>
                            <Tabs.TabPane tab={<span style={{ fontWeight: 'bold', color: '#1890ff' }}>New Complaint</span>} key="new">
                                <Card title={<Title level={4} style={{ margin: 0, color: '#1890ff' }}>Submit New Complaint</Title>} style={{ borderRadius: '8px', marginTop: '16px' }}>
                                    <Form
                                        form={form}
                                        layout="vertical"
                                        onValuesChange={(changedValues, allValues) => setDataField(allValues)}
                                        style={{ maxWidth: 800 }}
                                    >
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Mobile Number</span>}
                                                    name="mobile"
                                                    validateStatus={getDataError.mobile ? 'error' : ''}
                                                    help={getDataError.mobile ? 'Mobile Number is required' : ''}
                                                >
                                                    <Input placeholder="Enter Mobile Number" size="large" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Biller</span>}
                                                    name="biller"
                                                    validateStatus={getDataError.biller ? 'error' : ''}
                                                    help={getDataError.biller ? 'Biller is required' : ''}
                                                >
                                                    <Input placeholder="Enter Biller" size="large" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Amount</span>}
                                                    name="amount"
                                                    validateStatus={getDataError.amount ? 'error' : ''}
                                                    help={getDataError.amount ? 'Amount is required' : ''}
                                                >
                                                    <Input type="number" placeholder="Enter Amount" size="large" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Type Of Complaint</span>}
                                                    name="typeOfComplaint"
                                                    validateStatus={getDataError.typeOfComplaint ? 'error' : ''}
                                                    help={getDataError.typeOfComplaint ? 'Type Of Complaint is required' : ''}
                                                >
                                                    <Input placeholder="Enter Type Of Complaint" size="large" />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Participation Type</span>}
                                                    name="participationType"
                                                    validateStatus={getDataError.participationType ? 'error' : ''}
                                                    help={getDataError.participationType ? 'Participation Type is required' : ''}
                                                >
                                                    <Select 
                                                        placeholder="Select Participation Type"
                                                        size="large"
                                                        options={[
                                                            { label: 'Individual', value: 'individual' },
                                                            { label: 'Group', value: 'group' },
                                                            { label: 'Organization', value: 'organization' },
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Service Reason</span>}
                                                    name="serviceReason"
                                                    validateStatus={getDataError.serviceReason ? 'error' : ''}
                                                    help={getDataError.serviceReason ? 'Service Reason is required' : ''}
                                                >
                                                    <Select 
                                                        placeholder="Select Service Reason"
                                                        size="large"
                                                        options={[
                                                            { label: 'Billing Issue', value: 'billing_issue' },
                                                            { label: 'Payment Failure', value: 'payment_failure' },
                                                            { label: 'Service Outage', value: 'service_outage' },
                                                            { label: 'Other', value: 'other' },
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Description</span>}
                                                    name="description"
                                                    validateStatus={getDataError.description ? 'error' : ''}
                                                    help={getDataError.description ? 'Description is required' : ''}
                                                >
                                                    <TextArea rows={3} placeholder="Enter Complaint Description" />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Form.Item style={{ marginBottom: 0 }}>
                                            <Button type="primary" size="large" shape="round" onClick={handleSubmit} block style={{ background: 'linear-gradient(45deg, #1890ff, #40a9ff)', border: 'none' }}>
                                                Submit Complaint
                                            </Button>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={<span style={{ fontWeight: 'bold', color: '#52c41a' }}>Check Complaint Status</span>} key="check">
                                <Card title={<Title level={4} style={{ margin: 0, color: '#52c41a' }}>Track Your Complaint</Title>} style={{ borderRadius: '8px', marginTop: '16px' }}>
                                    <Form
                                        form={statusForm}
                                        layout="vertical"
                                        style={{ maxWidth: 600 }}
                                    >
                                        <Row gutter={16} justify="center" align="middle">
                                            <Col span={24}>
                                                <Title level={5} style={{ textAlign: 'center', color: '#52c41a', marginBottom: '24px' }}>Enter details to check status</Title>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Complaint ID</span>}
                                                    name="complaintId"
                                                    rules={[{ required: true, message: 'Complaint ID is required' }]}
                                                >
                                                    <Input 
                                                        value={complaintId} 
                                                        onChange={(e) => setComplaintId(e.target.value)} 
                                                        placeholder="Enter your Complaint ID" 
                                                        size="large"
                                                        prefix={<span style={{ color: '#52c41a', fontSize: '18px' }}>📋</span>}
                                                        style={{ borderRadius: '8px' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Service Type</span>}
                                                    name="serviceType"
                                                    rules={[{ required: true, message: 'Service Type is required' }]}
                                                >
                                                    <Select 
                                                        value={serviceType || undefined} 
                                                        onChange={setServiceType} 
                                                        placeholder="Select Service Type"
                                                        size="large"
                                                        style={{ borderRadius: '8px' }}
                                                        options={[
                                                            { label: 'Billing Issue', value: 'billing_issue' },
                                                            { label: 'Payment Failure', value: 'payment_failure' },
                                                            { label: 'Service Outage', value: 'service_outage' },
                                                            { label: 'Other', value: 'other' },
                                                        ]}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row justify="center" style={{ marginTop: '16px' }}>
                                            <Col>
                                                <Button 
                                                    type="primary" 
                                                    size="large" 
                                                    shape="round" 
                                                    onClick={handleStatusCheck} 
                                                    style={{ 
                                                        background: 'linear-gradient(45deg, #52c41a, #73d13d)', 
                                                        border: 'none',
                                                        boxShadow: '0 2px 8px rgba(82, 196, 26, 0.3)'
                                                    }}
                                                >
                                                    Check Status
                                                </Button>
                                            </Col>
                                        </Row>
                                        {statusResult && (
                                            <Row justify="center" style={{ marginTop: '32px' }}>
                                                <Col span={24}>
                                                    <Card 
                                                        title={<Title level={5} style={{ margin: 0, color: '#1890ff' }}>Status Update</Title>} 
                                                        style={{ 
                                                            borderRadius: '12px', 
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                                            background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)'
                                                        }}
                                                    >
                                                        <Row gutter={16}>
                                                            <Col span={8}>
                                                                <div style={{ textAlign: 'center', padding: '8px' }}>
                                                                    <span style={{ fontSize: '24px', color: '#52c41a' }}>📄</span>
                                                                    <p style={{ margin: '4px 0 0 0', fontWeight: 'bold' }}>Complaint ID</p>
                                                                    <p style={{ color: '#333', margin: 0 }}>{statusResult.complaintId}</p>
                                                                </div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div style={{ textAlign: 'center', padding: '8px' }}>
                                                                    <span style={{ fontSize: '24px', color: '#faad14' }}>⚙️</span>
                                                                    <p style={{ margin: '4px 0 0 0', fontWeight: 'bold' }}>Service Type</p>
                                                                    <p style={{ color: '#333', margin: 0 }}>{serviceMap[statusResult.serviceType] || statusResult.serviceType}</p>
                                                                </div>
                                                            </Col>
                                                            <Col span={8}>
                                                                <div style={{ textAlign: 'center', padding: '8px' }}>
                                                                    <span style={{ fontSize: '24px', color: statusResult.status === 'Resolved' ? '#52c41a' : '#faad14' }}>
                                                                        {statusResult.status === 'Resolved' ? '✅' : '⏳'}
                                                                    </span>
                                                                    <p style={{ margin: '4px 0 0 0', fontWeight: 'bold' }}>Status</p>
                                                                    <p style={{ color: '#333', margin: 0, fontSize: '16px', fontWeight: 'bold' }}>{statusResult.status}</p>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}
                                    </Form>
                                </Card>
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={<span style={{ fontWeight: 'bold', color: '#fa8c16' }}>History</span>} key="history">
                                <Card 
                                    title={
                                        <Title level={3} style={{ margin: 0, color: '#fa8c16' }}>
                                            Complaint <span style={{ color: '#ff4d4f' }}>History</span>
                                        </Title>
                                    } 
                                    style={{ borderRadius: '8px', marginTop: '16px' }}
                                >
                                    <Form
                                        form={historyForm}
                                        layout="vertical"
                                        style={{ maxWidth: '100%' }}
                                    >
                                        <Row gutter={16} style={{ marginBottom: '24px' }}>
                                            <Col span={6}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>From Date</span>}
                                                    name="fromDate"
                                                >
                                                    <DatePicker 
                                                        format={dateFormat} 
                                                        value={fromDate} 
                                                        onChange={setFromDate} 
                                                        size="large"
                                                        style={{ width: '100%', borderRadius: '8px' }}
                                                        placeholder="Select From Date"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>To Date</span>}
                                                    name="toDate"
                                                >
                                                    <DatePicker 
                                                        format={dateFormat} 
                                                        value={toDate} 
                                                        onChange={setToDate} 
                                                        size="large"
                                                        style={{ width: '100%', borderRadius: '8px' }}
                                                        placeholder="Select To Date"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Search By</span>}
                                                    name="searchBy"
                                                >
                                                    <Select 
                                                        value={searchBy} 
                                                        onChange={setSearchBy} 
                                                        size="large"
                                                        style={{ width: '100%', borderRadius: '8px' }}
                                                        options={[
                                                            { label: "Transaction ID", value: "ID" },
                                                            { label: "Mobile", value: "mobile" }
                                                        ]}
                                                        placeholder="Select Search By"
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    label={<span style={{ color: '#333', fontWeight: 500 }}>Search Value</span>}
                                                    name="searchValue"
                                                >
                                                    <Input 
                                                        placeholder="Enter search value..." 
                                                        value={searchValue}
                                                        onChange={(e) => setSearchValue(e.target.value)}
                                                        size="large"
                                                        style={{ width: '100%', borderRadius: '8px' }}
                                                        prefix={<span style={{ color: '#fa8c16' }}>🔍</span>}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row justify="end" style={{ marginBottom: '24px' }}>
                                            <Col>
                                                <Button 
                                                    type="primary" 
                                                    size="large" 
                                                    shape="round" 
                                                    onClick={handleSearch} 
                                                    style={{ 
                                                        background: 'linear-gradient(45deg, #fa8c16, #ffa940)', 
                                                        border: 'none',
                                                        boxShadow: '0 2px 8px rgba(250, 140, 22, 0.3)'
                                                    }}
                                                >
                                                    Apply Filters
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                    <Divider style={{ margin: '24px 0', borderColor: '#fa8c16' }} />
                                    <Card 
                                        style={{ 
                                            borderRadius: '12px', 
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                            backgroundColor: '#fff'
                                        }}
                                    >
                                        <DataTable
                                            title={
                                                <Title level={5} style={{ margin: 0, color: '#fa8c16' }}>
                                                    Your Complaint Records ({filteredData.length})
                                                </Title>
                                            }
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            pagination
                                            paginationServer
                                            customStyles={{
                                                table: {
                                                    style: {
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                    },
                                                },
                                                headRow: {
                                                    style: {
                                                        background: 'linear-gradient(45deg, #fa8c16, #ffa940)',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                    },
                                                },
                                                headCells: {
                                                    style: {
                                                        fontWeight: 'bold',
                                                        borderBottom: '2px solid #e6f7ff',
                                                    },
                                                },
                                                rows: {
                                                    style: {
                                                        borderBottom: '1px solid #f0f0f0',
                                                        '&:hover': {
                                                            backgroundColor: '#f6ffed',
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    </Card>
                                </Card>
                            </Tabs.TabPane>
                        </Tabs>
                    </Card>
                </Col>
            </Row>
            {isSubmit && (<Modal 
                open={isSubmit} 
                onCancel={() => setSubmit(false)} 
                width={500} 
                footer={false} 
                title={<div className='col-md-12 row text-left'>
                    <div className='col-md-6'>
                        <img className='text-left' src='../logo.png' alt='photos' width={"50%"} />
                    </div>
                    <div className='col-md-6 text-right'>
                        <img className='text-right' src={'../images/bharat-billpay-logo-1@2x.png'} alt='photos' width={"40%"} />
                    </div>
                </div>}
                style={{ borderRadius: '12px' }}
            >
                <ComplaintSubmit message="Your complaint has been submitted successfully. Complaint no. #876398" />
            </Modal>)}
            <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
        </div>
    )
}

export default Complaint